jQuery(document).ready(function(){

  // detect touch devices
  function is_touch_device() {
   return 'ontouchstart' in window        // works on most browsers
    || navigator.maxTouchPoints;       // works on IE10/11 and Surface
  };

  if ( is_touch_device() ) {
    jQuery('html').addClass('touch')
  } else {
    jQuery('html').addClass('no-touch')
  }

});
